import Lazyload from 'vue-lazyload';
import 'bh-mint-ui2/src/style/empty.css';

export default Lazyload;



// WEBPACK FOOTER //
// ./packages/lazyload/src/lazyload.js